<video autoplay class="vid" controls>
  <source [src]="videoUrl" type="video/mp4" />
</video>
